import { SET_PROVIDER_DATA } from '../helpers/constants/actionsConstants';

import type { SetProviderDataAction } from './types';
import type { BrowseContextProviderData } from 'src/services/contextAdaptor/types';

const setProviderData = (
  priceProviderData: BrowseContextProviderData,
): SetProviderDataAction => ({
  type: SET_PROVIDER_DATA,
  payload: priceProviderData,
});

export default {
  setProviderData,
};
